"use strict";import{ColorWheel as e}from"./src/ColorWheel.js";import{defineElement as l}from"@spectrum-web-components/base/src/define-element.js";l("sp-color-wheel",e);
//# sourceMappingURL=sp-color-wheel.js.map
